import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { PageHyundaiPromiseVM } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './hyundai-promise-vm.actions';

interface Content {
    content: Loadable<PageHyundaiPromiseVM>;
    error: string | null;
}

const initialState: Content = {
    content: null,
    error: null,
};

export const state = createFeature({
    name: 'promiseVM',
    reducer: createReducer(
        initialState,

        on(
            actions.loadHyundaiPromiseVM,
            (state): Content => ({
                ...state,
                content: null,
                error: null,
            }),
        ),
        on(
            actions.loadHyundaiPromiseVMSuccess,
            (state, { content }): Content => ({
                ...state,
                content: content,
            }),
        ),
        on(
            actions.loadHyundaiPromiseVMFailure,
            (state, { error }): Content => ({
                ...state,
                error: error,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingPromise = createSelector(
            baseSelectors.selectContent,
            baseSelectors.selectError,
            (promiseContent, error) => promiseContent === null && error === null,
        );
        const selectLoadedContent = createSelector(
            baseSelectors.selectContent,
            (content) => content as Loaded<PageHyundaiPromiseVM>,
        );
        return {
            selectIsLoadingPromise,
            selectLoadedContent,
        };
    },
});
